export const VENDOR_REPORT_SECTION_ID = "vendor-report-section";
export const VENDOR_REPORT_SECTION_ID = "vendor-report-section";
